import { ReactNode, createContext } from 'react';
import useProvideAuth from '@/hooks/useProvideAuth';

interface AuthContextType {
  user: any;
  logIn: (username: string, password: string, sessionCloseMode?: 'closeOldest' | 'closeAll') => Promise<any>;
  logOut: () => Promise<any>;
  setUser: React.Dispatch<React.SetStateAction<{}>>;
  signUp: (username: string, password: string) => void;
  sendPasswordResetEmail: (email: string) => void;
  confirmPasswordReset: (code: string, password: string) => void;
}

const AuthContext = createContext<AuthContextType>(null!);
// user: {},
// logIn: useProvideAuth().logIn,
// logOut: useProvideAuth().logOut,
// setUser: useProvideAuth().setUser,
// signUp: useProvideAuth().signUp,
// sendPasswordResetEmail: useProvideAuth().sendPasswordResetEmail,
// confirmPasswordReset: useProvideAuth().confirmPasswordReset,

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  // const [auth, setAuth] = useState({});

  const value = useProvideAuth();

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext;
